import { v4 as uuidv4 } from 'uuid'

export const getUuidV4 = () => {
  return uuidv4()
}
